import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NewRelicService {
  constructor() {}

  setUserId(underId: string): void {
    try {
      if (typeof newrelic !== 'undefined' && newrelic?.setUserId) {
        newrelic.setUserId(underId);
      }
    } catch (error) {
      console.warn('NewRelic setUserId failed:', error);
    }
  }

  setCustomAttribute(attribute: string, value: any): void {
    try {
      if (typeof newrelic !== 'undefined' && newrelic?.setCustomAttribute) {
        newrelic.setCustomAttribute(attribute, value);
      }
    } catch (error) {
      console.warn('NewRelic setCustomAttribute failed:', error);
    }
  }

  /*
    message: the log message to display
    level: must be one of: debug | error | info | trace | warn
    customAttributes: an object of key:val pairs
    ex: newrelic.log('test log', {level: 'info', customAttributes: {policyNumber: '123456'}})
  */
  captureLogEvent(message: string, level: string = 'info', customAttributes?: any): void {
    try {
      // Check if newrelic is available at runtime
      if (typeof newrelic === 'undefined') {
        console.warn('NewRelic is not loaded yet');
        return;
      }

      // Validate and normalize the log level
      const validLevels = ['debug', 'error', 'info', 'trace', 'warn'];
      const normalizedLevel = level && validLevels.includes(level.toLowerCase()) 
        ? level.toLowerCase() 
        : 'info';
      const logOptions: any = { level: normalizedLevel };
      if (customAttributes) {
        logOptions.customAttributes = customAttributes;
      }
      if (newrelic?.log) {
        newrelic.log(message, logOptions);
      }
    } catch (error) {
      console.warn('NewRelic captureLogEvent failed:', error);
    }
  }
}
